<template>
  <transition appear name="fade">
    <v-card flat tile class="d-flex poly-search-result" dark @click="selected">
      <v-img
        :src="result.thumbnail.url"
        aspect-ratio="1.6"
        class="grey lighten-2 poly-search-result__thumbnail"
      >
        <v-layout
          slot="placeholder"
          fill-height
          align-center
          justify-center
          ma-0
        >
          <v-progress-circular indeterminate color="secondary"></v-progress-circular>
        </v-layout>
      </v-img>
      <v-progress-circular v-if="loading" indeterminate color="secondary" class="loading"></v-progress-circular>
    </v-card>
  </transition>
</template>

<script>
import EventBus from '@/event-bus.js'

export default {
  name: 'PolySearchResult',
  props: {
    result: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    selected () {
      console.log(EventBus)
      this.loading = true
      this.$emit('selected', this.result)
      EventBus.$once('node-loaded', this.loaded)
      EventBus.$once('node-error', this.error)
      console.log(this.result)
    },
    loaded () {
      this.loading = false
      EventBus.$off('node-loaded', this.loaded)
      EventBus.$off('node-error', this.error)
    },
    error () {
      this.loading = false
      EventBus.$off('node-loaded', this.loaded)
      EventBus.$off('node-error', this.error)
    }
  }
}
</script>

<style scoped lang="scss">
.poly-search-result__thumbnail {
  transition: opacity 0.3s ease;
}
.poly-search-result:hover {
  cursor: pointer;

  .poly-search-result__thumbnail {
    opacity: 0.4;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
